import React, { useState, useCallback, useContext } from "react";
import { Button, Modal, Container, Row, Col, Alert } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { createProductoService } from "../../utils/ProductoService";
import AuthContext from "../../context/AuthContext";

function CreateProductoModal({ productos, setProductos }) {
  const { authTokens } = useContext(AuthContext);
  // States del Modal
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  // clean state
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // States de los campos del form.
  const [producto, setProducto] = useState("");
  const [marca, setMarca] = useState("");
  const [precio, setPrecio] = useState("");
  const [tarjeta, setTarjeta] = useState("");
  const [stock, setStock] = useState("");

  // Funcion encargada de crear el producto en la db.
  const createProducto = useCallback(async (producto) => {
    createProductoService(producto, authTokens).then((response) => {
      productos.push(response);
      const aux = productos.map((cli) => cli);
      setProductos(aux);
    });
  });

  // Funcion encargada de poner en mayuscula campos importantes
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Funcion encargada de tomar los datos del form y actualizar el producto en la DB.
  async function handleCreate() {
    const productoCreado = {
      producto: capitalizeFirstLetter(producto),
      marca: capitalizeFirstLetter(marca),
      precio: precio,
      tarjeta: tarjeta,
      stock: parseInt(stock),
    };
    // Verificamos que todos los campos del form estan completos
    if (
      productoCreado.producto !== "" &&
      productoCreado.marca !== "" &&
      productoCreado.precio !== "" &&
      productoCreado.tarjeta !== "" &&
      !isNaN(productoCreado.stock)
    ) {
      // Aca tenemos que llamar a la funcion que va a hacer el servicio de crear al nuevo cliente en el back y le pasamos los datos.
      createProducto(productoCreado);
      handleClean();
      handleClose();
    } else {
      setError(true);
    }
  }

  // Funcion encargada de volver a cargar los valores originales en cada input del formulario cuando se cancela el edit.
  const handleClean = () => {
    setProducto("");
    setMarca("");
    setPrecio("");
    setTarjeta("");
    setStock("");
    setError(false);

    handleClose();
  };

  return (
    <>
      <Button variant="success" size="sm" onClick={handleShow}>
        Nuevo Producto
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton onClick={handleClean}>
          <Modal.Title>Crear nuevo producto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Container>
            {error && (
              <Alert variant="danger">Debe completar todos los campos!</Alert>
            )}
            <Row>
              <Col xs={12} md={6}>
                <Form.Group
                  tabIndex={-1}
                  onChange={(e) => {
                    setProducto(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Producto:</Form.Label>
                  <Form.Control
                    type="text"
                    required={true}
                    defaultValue={producto}
                    placeholder="Producto"
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={6}>
                <Form.Group
                  onChange={(e) => {
                    setMarca(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Marca:</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue={marca}
                    placeholder="Marca"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrecio(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Precio Efectivo:</Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue={precio}
                    placeholder="Precio Efectivo"
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setTarjeta(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Precio Tarjeta:</Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue={tarjeta}
                    placeholder="Precio Tarjeta"
                  />
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setStock(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Stock:</Form.Label>
                  <Form.Control
                    type="number"
                    defaultValue={stock}
                    placeholder="Stock"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" size="sm" onClick={handleClean}>
            Cancelar
          </Button>
          <Button
            onClick={() => handleCreate()}
            variant="outline-success"
            size="sm"
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CreateProductoModal;
